import {LAB_REPORT } from "@/api_framework/api_config";
import { useAppDispatch } from "@/app_redux/hooks/root_hook";
import axios, { AxiosError, AxiosResponse } from "axios";
import { useCallback, useState } from "react";
import toast from "react-hot-toast";
import AxiosCurlirize from "axios-curlirize";
import { useAPIUtils } from "../../useAPIUtils";
import { useConfiguration } from "../../useConfiguration";
import { useCurlLogger } from "../../useCurlLogger";
import { ILabDetailsResponse, ILabDetailsResponseData } from "@/api_framework/api_modals/LabReport";

AxiosCurlirize(axios, () => {});
export const useLabDetailsAPI = () => {
  const configuration = useConfiguration();
  const dispatch = useAppDispatch();
  const [labDetails, setLabDetails] = useState<ILabDetailsResponseData | null>(null);

  const { captureError } = useAPIUtils();
  const { sendCurl } = useCurlLogger();
  const execute = useCallback(
    async (requisition_id: string, test_id: string) => {
      try {
        const accessToken = localStorage.getItem(configuration.localStorage.ACCESS_TOKEN.key);

        const response: ILabDetailsResponseData = await axios
               .get(`${LAB_REPORT?.LAB_DETAILS?.baseURL}${requisition_id}/lab-partners/${test_id}/`, {
            // params: {
            //   requisition_id: requisition_id,
            //   test_id: test_id
            // },
            headers: {
              Authorization: `${accessToken}`,
              "Content-Type": "application/json",
            },
          })
          .then((res: AxiosResponse<ILabDetailsResponse>) => {
            if (res.data.status === true && res.data) {
              setLabDetails(res.data.data);
              return res.data.data;
            } else {
              setLabDetails(null);
              return null;
            }
          })
          .catch((e: AxiosError) => {
            setLabDetails(null);
            captureError(e);
            sendCurl(e.config["curlCommand"]);

            return null;
          });
        return response;
      } catch (e: any) {
        setLabDetails(null);
        toast.error("Server Error: " + e.message);
      }
    },
    [dispatch],
  );
  return { execute, labDetails };
};
